import { render, staticRenderFns } from "./NoticeIcon.vue?vue&type=template&id=7bac88f8&scoped=true"
import script from "./NoticeIcon.vue?vue&type=script&lang=js"
export * from "./NoticeIcon.vue?vue&type=script&lang=js"
import style0 from "./NoticeIcon.vue?vue&type=style&index=0&id=7bac88f8&prod&lang=css&scoped=true"
import style1 from "./NoticeIcon.vue?vue&type=style&index=1&id=7bac88f8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bac88f8",
  null
  
)

export default component.exports